<template>
    <h2 class="heading" style="width:1110px;">Payment Details</h2>
    <div class="detail">
        <table>
            <tr><th>Request No</th> <td>{{payment.id}}</td></tr>
            <tr><th>Payment category</th> <td>{{payment.category=='Others' ? payment.category2 : payment.category}}</td></tr>
            <tr><th>Purpose of payment</th> <td>{{payment.purpose}}</td></tr>
            <tr><th>Description</th> <td>{{payment.descriptionHTML}}</td></tr>
            <tr><th>Request date</th> <td>{{payment.requestDate}}</td></tr>
            <tr><th>Requester</th> <td>{{payment.requester}}</td></tr>
            <tr><th>Creator</th> <td>{{payment.creator}}</td></tr>
            <tr><th>Submitted at</th> <td>{{payment.createTime}}</td></tr>
            <tr v-if="payment.relatedTo != ''"><th>Payment related to</th> <td>{{payment.relatedTo}}</td></tr>
            <tr v-if="payment.relatedETFs && payment.relatedETFs.length"><th>Related ETFs</th> 
                <td><el-tag v-for="etf in payment.relatedETFs.split(',')" :key="etf" >{{etf}}</el-tag></td></tr>
            <tr><th>Pay from</th> <td>{{payment.payFrom}}</td></tr>
            <tr><th>Pay to</th> <td>{{payment.payTo}}</td></tr>
            <tr><th>Status</th> <td :class="payment.status"><b>{{payment.status}}</b></td></tr>
            <tr v-if="payment.invoiceNumber != ''"><th>Invoice number</th> <td>{{payment.invoiceNumber}}</td></tr>
            <tr v-if="payment.invoiceDate != null"><th>Invoice date</th> <td>{{payment.invoiceDate}}</td></tr>
            <tr><th>Invoice files</th> 
                <td>
                    <el-tag v-for="(item, index) in invoiceFiles" :key="index" size="large" @close="removeFile(item)">
                    <a href="" @click.prevent="global.down(item.link, item.name)">{{item.name}}</a></el-tag>
                </td>
            </tr>
            <tr><th>Payment method</th> <td>{{payment.paymentMethod}}</td></tr>
            <tr><th>Contract</th> <td>
                <template v-if="contract"><span style="color:#888;">
                    { ID: #{{contract.id}}, Nature: {{contract.nature}}, Vendor: {{ contract.vendorName }}, Service: {{ contract.service }}, 
                    Related ETFs: {{ contract.relatedETFs }}, <br/> 
                    Contract Amount: <b style="color:#369; font-size:1.0em;">{{ contract.contractAmount }}</b> 
                    ({{ contract.currency }}), Billding Frequency: {{ contract.billingFrequency }} }
                </span></template>
            </td></tr>

            <tr><th>Amount (ccy)</th> <td><span class="amount">{{global.number_format(payment.amount, 2)}}</span> 
                <span class="unit"> ({{payment.currency}}) </span></td></tr>
            <tr v-if="payment.fxRate != 0"><th>FX rate</th> <td>{{payment.fxRate}}</td></tr>
            <tr v-if="payment.amountHKD != 0"><th>Amount in HKD</th> <td>{{payment.amountHKD}} <span class="unit">HKD</span></td></tr>
            <tr v-if="payment.serviceChargeHKD != 0"><th>Service Charge</th> <td>{{payment.serviceChargeHKD}} <span class="unit">HKD</span></td></tr>
            <tr v-if="payment.commissionChargeHKD != 0"><th>Commission or other changes</th> <td>{{payment.commissionChargeHKD}} <span class="unit">HKD</span></td></tr>
            <tr v-if="payment.postageHKD != 0"><th>Postage / cable fees</th> <td>{{payment.postageHKD}} <span class="unit">HKD</span></td></tr>
            <tr v-if="payment.additionalChargesHKD != 0"><th>Additional handling charges</th> <td>{{payment.additionalChargesHKD }}  <span class="unit">HKD</span></td></tr>
            <tr v-if="payment.totalAmountHKD != 0"><th>Total amount</th> <td><b>{{payment.totalAmountHKD }}</b> <span class="unit">HKD</span></td></tr>
            <tr v-if="payment.referenceNumber != ''"><th>Reference number</th> <td>{{payment.referenceNumber }}</td></tr>
            <tr v-if="payment.reimbursementFrom != null"><th>Reimbursement from</th> <td>{{payment.reimbursementFrom }}</td></tr>
            <tr v-if="payment.reimbursementDate != null"><th>Reimbursement date</th> <td>{{payment.reimbursementDate }}</td></tr>
            <tr><th>Departments</th> <td><el-tag v-for="dept in payment.departmentsArr" :key="dept" >{{dept}}</el-tag></td></tr>
            <tr><th>Approver</th> <td>{{payment.approver }}</td></tr>
            <tr><th>Payment date</th>
            <td>
                <span v-if="canApprove"><el-date-picker v-model="payment.paymentDate" type="date" placeholder="Payment date" 
                    value-format="YYYY-MM-DD"></el-date-picker></span>
                <span v-else>{{payment.paymentDate}}</span>
            </td></tr>
            <tr v-if="payment.signOffList != null"><th>SignOff</th> 
                <td>
                    <table class="signOff" cellspacing="0">
                        <tr class="thead"><td>Department</td>
                            <td>Sign Off</td>
                            <td>Date</td>
                            <td>Comments</td>
                            <td>Result</td>
                        </tr>
                        <tr v-for="(item, index) in payment.signOffList" :key="index">
                            <td>{{item.dept}}</td>
                            <td>{{item.username}}</td>
                            <td>{{item.date}}</td>
                            <td :class="item.status=='rejected'?'rejected':'approved'"><span v-html="item.comments"></span></td>
                            <td>{{!item.status ? "approved" : item.status}}</td>
                        </tr>
                    </table>
                </td>
            </tr>
            
            <tr v-if="payment.requesterRemarks && payment.requesterRemarks != '' && payment.status == 'updated' ">
                <th>Requester's remarks</th>
                <td>
                    <span style="color:#33e;font-weight:bold;">{{payment.requesterRemarks}}</span>
                </td>
            </tr>
            <tr v-if="payment.canConfirm"><th>Requester's remarks</th> 
                <td><el-input v-model="remarks" type="textarea" /> </td>
            </tr>
            <tr v-if="canSignOff || canApprove">
                <th>{{canApprove ? "Approver" : dept}}'s comments<i class="required"></i></th>
                <td><el-input type='textarea' v-model="comments" id="comments"></el-input></td>
            </tr>

            <template v-if="canReview || canReview2">
                <tr>
                    <th>Review result</th>
                    <td>
                        <el-radio-group v-model="status">
                            <el-radio label="confirmed" class="approved">Confirmed</el-radio>
                            <el-radio label="rejected" class="rejected">Rejected</el-radio>
                        </el-radio-group>
                    </td>
                </tr>
                <tr>
                    <th>Confirmor's comments</th>
                    <td><el-input type='textarea' v-model="comments" id="comments"></el-input></td>
                </tr>
            </template>

            <tr v-if="canApprove">
                <th>Approve result</th>
                <td>
                    <el-radio-group v-model="status">
                        <el-radio label="approved" class="approved">Approved</el-radio>
                        <el-radio label="disapproved" class="rejected">Disapproved</el-radio>
                        <el-radio label="rejected" class="rejected">Rejected</el-radio>
                    </el-radio-group>
                </td>
            </tr>

            <tr v-if="canReview || canReview2 || canSignOff || canApprove">
                <th>{{canSignOff ? "Signoff" : canApprove ? "Approver" : "Confirmor"}}</th>
                <td>
                    <div class="signature">{{global.currentUser.fullname}} <span class="date">( {{today}} )</span>
                    </div>
                </td>
            </tr>
            <tr v-if="payment.approverComments && payment.approverComments != '' && (payment.status == 'rejected' || payment.status == 'rejected') ">
                <th>Approver's comments</th>
                <td>
                    <span style="color:#e33;font-weight:bold;">{{payment.approverComments}}</span>
                </td>
            </tr>
        </table>
        <div v-if="errMsg != ''" style="width:1024px;margin-top:15px;"><el-alert :title="errMsg" type="error" /></div>
        <div class="buttonDIV" style="width:1100px;">
            <el-button v-if="canApprove" @click="approvePayment" style="margin-right:10px;" type="primary">Submit</el-button>
            <el-button v-if="canReview" @click="reviewPayment" style="margin-right:10px;" type="primary">Submit</el-button>
            <el-button v-if="canReview2" @click="review2Payment" style="margin-right:10px;" type="primary">Submit</el-button>
            <el-button v-if="canSignOff" @click="signOffPayment" style="margin-right:10px;" type="primary">Signoff the payment</el-button>
            <el-button v-if="payment.canConfirm" @click="confirmPayment" style="margin-right:10px;" type="primary">Confirm the payment</el-button>
            <el-button @click="backPaymentList">Back to payments list</el-button>
        </div>
    </div>
</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            payment: {},
            canSignOff: false,
            dept: '',
            canConfirm: false,
            canApprove: false,
            canReview: false,
            canReview2: false,
            signOffList: [],
            today: '',
            status: null,
            remarks: '',
            comments: '',
            errMsg: '',
            code: null,
            global,
            loading: false,
            contract: null,
        }
    },
    computed: {
        invoiceFiles() {
            let files = new Array();
            if (this.payment.invoiceFiles && this.payment.invoiceFiles.length) {
                let filesArr = this.payment.invoiceFiles.split(";")
                for (var i = 0; i < filesArr.length; i++) {
                    files.push({
                        name: filesArr[i].split(":")[0], 
                        link: filesArr[i].split(":")[1]
                    });
                }
            }
            return files;
        },
        departments() {
            if (this.payment.departments && this.payment.departments.length) 
                return this.payment.departments.split(",");
            return new Array();
        }
    },
    async mounted() {
        this.global.index = "payment";
        this.code = this.$route.query.code;
        let result = await AXIOS("/payment/getPaymentByCode", {code: this.code});
        if (result.success) {
            this.payment = result.data.payment;
            if (this.payment && this.payment.contractId) {
                let result = await AXIOS("/contract/getContract", {contractId: this.payment.contractId});
                if (result.success) {
                    this.contract = result.data;
                }
            }
            this.dept = result.data.dept;
            this.canSignOff = this.payment.canSignOff;
            this.canConfirm = this.payment.canConfirm;
            this.canApprove = this.payment.canApprove;
            this.canReview = this.payment.canReview;
            this.canReview2 = this.payment.canReview2;
            this.signOffList = result.data.signOffList;
            this.today = result.data.today;
        } else {
            this.errMsg = result.errMsg;
        }
    },
    methods: {
        backPaymentList() {
            let fromPath = sessionStorage.getItem("fromPath");
            if (fromPath && fromPath.startsWith("/payment/")) {
                this.$router.push(fromPath);
            } else {
               if (this.global.hasRight('payments', 'approver') || this.global.hasRight('payments', 'statistician')) {
                   this.$router.push('/payment/allPaymentList');
               } else {
                   this.$router.push('/payment/myPaymentList');
               }
            }
        },
        async confirmPayment() {
            this.errMsg = "";
            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let data = {code: this.code, remarks: this.remarks};
            let result = await AXIOS("/payment/confirmPayment", data);
            if (result.success) {
                this.backPaymentList();
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
        async signOffPayment() {
            let data = { code: this.code, comments: this.comments };
            this.errMsg = "";
            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let result = await AXIOS("/payment/signoffPayment", data);
            if (result.success) {
                this.backPaymentList();
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },
        async reviewPayment() {
            this.errMsg = '';
            if (this.status == null) {
                this.errMsg = "Please select 'Review result'";
                return;
            } else if (this.status == 'rejected') {
                if (this.comments == '') {
                    this.errMsg = "Please input 'Confirmor's comments'";
                    return;
                }
            }

            if (this.loading) return;
            this.loading = true;
            let data = { code: this.code, comments: this.comments, status: this.status };
            let result = await AXIOS("/payment/reviewPayment", data);
            if (result.success) {
                this.backPaymentList();
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },

        async review2Payment() {
            this.errMsg = '';
            if (this.status == null) {
                this.errMsg = "Please select 'Review result'";
                return;
            } else if (this.status == 'rejected') {
                if (this.comments == '') {
                    this.errMsg = "Please input 'Confirmor's comments'";
                    return;
                }
            }

            if (this.loading) return;
            this.loading = true;
            let data = { code: this.code, comments: this.comments, status: this.status };
            let result = await AXIOS("/payment/review2Payment", data);
            if (result.success) {
                this.backPaymentList();
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        },

        async approvePayment() {
            this.errMsg = '';
            if (this.status == null) {
                this.errMsg = "Please select 'Approve result'";
                return;
            } else if (this.status == 'rejected' || this.status == 'disapproved') {
                if (this.comments == '') {
                    this.errMsg = "Please input 'Approver's comments'";
                    return;
                }
            }

            if (this.loading) return;
            this.loading = true;
            let data = { code: this.code, comments: this.comments, status: this.status, paymentDate: this.payment.paymentDate};
            let result = await AXIOS("/payment/approvePayment", data);
            if (result.success) {
                this.backPaymentList();
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .detail th { width: 160px; }
    .signOff {
        margin:10px 0px;
    }
    .rejected {color:#E20 !important;}
    .approved {color:#0A2;}
</style>